module.exports = __webpack_public_path__ + "static/img/banner_facein_face.27bb350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/banner/banner_facein_face.jpg
// module id = fanQ
// module chunks = 0